import { JsonView } from "react-json-view-lite";

const JsonDisplay = ({ data }) => {
  return (
    <div
      style={{
        padding: "10px",
        backgroundColor: "#f6f8fa",
        borderRadius: "4px",
      }}
    >
      <JsonView data={data} expandDepth={1} />
    </div>
  );
};

export default JsonDisplay;
